<template lang="pug">
  <div>
    v-app-bar(
      color="white"
      height="54px"
    )
        v-row(
          justify-lg="center" 
          justify-xs="left" 
          justify-md="center" 
          align-lg="center" 
          align-xs="left" 
          align-md="center"
        )
          v-app-bar-title(
              style="font-size: 16px; font-weight: 400;"
              class="text-center"
          ) 
            div Watch i-Memo introduction videos to learn how to use this software more easily.

          VideoTutorial
    v-app-bar(
      v-if="isMTEnv"
      color="orange"
      height="54px"
    )
        v-row(
          justify-lg="center" 
          justify-xs="left" 
          justify-md="center" 
          align-lg="center" 
          align-xs="left" 
          align-md="center"
        )
          v-app-bar-title(
              style="font-size: 16px; font-weight: 400;"
              class="text-center"
          ) 
            div(style='color:white') {{envMsg}}
  </div>
</template>

<script>
import VideoTutorial from "@/components/VideoTutorialDialog.vue";

export default {
    components: {
        VideoTutorial
    },
    computed: {
      isMTEnv() {
        if (process.env.MAINTENANCE_ALERT_MSG.length != 0) return true 
        return false
      },
      envMsg() {
        return process.env.MAINTENANCE_ALERT_MSG
      }
    }
  }
  
</script>

<style>
.btn-video{
    background: rgba(212, 42, 42, 0.1) !important;
    color: #D42A2A !important;
}
</style>
